// extracted by mini-css-extract-plugin
export default {"employee-container":"LoanRequest_employee-container__LW2Bj","loan-header":"LoanRequest_loan-header__9gUwm","loan-header__buttons":"LoanRequest_loan-header__buttons__rv3fe"};